<template>
  <div class="position-relative match-height">
    <!-- 标注弹层开关 播放音频视频时使用 -->
    <div id="body-source-wrap-audio" class="position-absolute">
      <audio ref="audio" style="display: none;" :src="src" autoplay controls="false" @loadedmetadata="onLoadedmetadata" @timeupdate="onTimeupdate" @play="onPlay" @pause="onPause" />
      <div class="body-source-wrap-audio-progress">
        <div class="body-source-wrap-audio-progress-slide flex-center">
          <el-slider v-model="audio.percent" class="match-width" @change="sliderchange" />
        </div>
        <div class="body-source-wrap-audio-control flex-row-center flex-row-center-between">
          <div class="audio-play-time flex-row-center">
            <div class="audio-play cursor" @click="playchange">
              <img v-if="!audio.playing" src="../../assets/icon-source-audio-play.png" alt="">
              <img v-else src="../../assets/icon-source-audio-play.png" alt="">
            </div>
            <div class="audio-time">
              <p class="font-color-fff font-14">{{ audio.currenttime | formatSecond }}/{{ audio.duration | formatSecond }}</p>
            </div>
          </div>
          <div class="audio-voice cursor" @click="audiomute">
            <img v-if="audio.mute" src="../../assets/icon-source-audio-mute.png" alt="">
            <img v-else src="../../assets/icon-source-audio-unmute.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

function fomartSeconds(second) {
  var secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
}

export default {
  filters: {
    formatSecond(second = 0) {
      return fomartSeconds(second)
    },
    formatPercent(v) {
      return v * 100
    }

  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      audio: {
        duration: 0,
        currenttime: 0,
        playing: false,
        percent: 0,
        volume: 0,
        mute: false
      }
    }
  },
  methods: {
    showSourceMark() {
      this.$emit('showmark')
    },
    onPlay() {
      this.audio.playing = true
    },
    onPause() {
      this.audio.playing = false
    },
    onTimeupdate(e) {
      this.audio.currenttime = e.target.currentTime
      this.audio.percent = (this.audio.currenttime / this.audio.duration) * 100
      if (this.audio.percent >= 100) {
        this.audio.percent = 100
      }
      console.error(this.audio.percent)
    },
    sliderchange(v) {
      this.audio.percent = v
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = this.audio.duration * v / 100
      this.$refs.audio.play()
    },
    audiomute() {
      if (this.$refs.audio.volume === 0) {
        this.$refs.audio.volume = this.audio.volume
        this.audio.mute = false
      } else {
        this.audio.volume = this.$refs.audio.volume
        this.audio.mute = true
        this.$refs.audio.volume = 0
      }
    },
    playchange() {
      if (this.audio.playing) {
        this.$refs.audio.pause()
      } else {
        this.$refs.audio.play()
      }
      this.audio.playing = !this.audio.playing
    },
    onLoadedmetadata(e) {
      this.audio.duration = parseInt(e.target.duration)
      this.audio.playing = true
      this.$emit('startPlay')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-slider__button-wrapper {
  z-index: 98 !important;
  top: -16px;
}

::v-deep .el-slider__button {
  width: 10px;
  height: 10px;
  background-color: #4C70E8;
  border: none;
}

::v-deep  .el-slider__bar {
  background-color: #4C70E8;
  height: 4px;
}

::v-deep .el-slider__runway {
  background-color: rgba(255, 255, 255, 0.5);
  height: 4px;
}

</style>
<style scoped>
#body-source-wrap-audio{
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* background-image: url("../../assets/icon-lib-source-audiobg.jpg"); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  #body-source-wrap-audio .body-source-wrap-audio-progress{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
  }

  .body-source-wrap-audio-progress-slide {
    height: 40px;
    padding: 0 20px !important;
  }

  .body-source-wrap-audio-control {
    height: 40px;
    padding: 0 20px !important;
  }

  .audio-slider {
    height: 4px;
    border-radius: 2px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .audio-slider-fill {
    width: 100%;
    top: 0;
    bottom: 0;
    border-radius: 2px;
    background-color: rgba(76, 112, 232, 0.8);
    justify-content: flex-end;
  }

  .audio-slider-thumb {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fff;
    overflow: auto;
  }

  .audio-play-time {
    height: 40px;
  }

  .audio-play-time .audio-play {
    margin-right: 14px;
  }

  .body-source-wrap-video-info-btn {
    top: 10px;
    right: 10px;
    z-index: 998;
  }
</style>
